import "./home.scss";
import template from "./home.html";
import {Base} from "../base";
import {Options} from "vue-class-component";
import {Toast} from 'bootstrap';
import Dixon from "../../assets/img/zen/teams/dixon-jones.jpg";
import Fred from "../../assets/img/zen/teams/fred-laurent.jpg";
import Hugo from "../../assets/img/zen/teams/hugo-fry.jpg";
import Marcos from "../../assets/img/zen/teams/marcos-richardson.jpg";
import Robert from "../../assets/img/zen/teams/robert-thackery.jpg";
import Gelan from "../../assets/img/zen/teams/gellan-watt.jpg";
import John from "../../assets/img/zen/teams/john-donovan.jpg";
import toastr from "toastr";


(window as any).Toast = Toast;

@Options({
	template,
})
export class Home extends Base {
	currentTeam: any = null;
	teams = [
		{
			name: "Hugo Fry",
			position: "Chair of the Board",
			image: Hugo,
			description_1: "Hugo Fry is Chief Executive Officer of RQ Biotechnology. Hugo has 28 years of senior management experience in the pharmaceutical and biotechnology industry across multiple business models and therapeutic areas, in UK, USA, France, Russia and Germany. Hugo has led Strategic and Operational Commercial teams, as well as heading R&D and Industrial Affairs teams.",
			description_2: "Hugo was Managing Director of Sanofi UK, Chief Marketing Officer for Sanofi Pasteur MSD (SPMSD) and a member of the Sanofi Diabetes Global Leadership Team. Hugo has held global strategic positions and commercial operational roles, leading vertically integrated teams from Drug Discovery through Clinical Development, Regulatory Affairs, Market Access, Industrial Affairs, Medical Affairs and Commercialisation.",
			description_3: "Hugo has also been Vice-President of the Association of the British Pharmaceutical Industry (ABPI).",
			description_4: "Hugo holds a B.Sc. in Chemistry from the University of Salford and studied Finance at London Business School and Leadership at Duke University."
		},
		{
			name: "John Donovan",
			position: "Legal and financial counsel",
			image: John,
			description_1: "John Donovan is a highly experienced business owner, director and serial investor.  His working career started in 1976 as a TV time buyer at the multi-national advertising agency, Ted Bates.  This has led to over 40 years' extensive experience and capability in media markets and commercial communications channels.",
			description_2: "In 1992, he founded his own media agency, Concord, which he stills runs, and successfully managed the necessary transition of the business to support clients and their businesses across both online and offline digital channels.  The enduring focus of Concord remains delivering an optimal return on investment to its clients.",
			description_3: "He has a very wide-ranging scope of client experience which extends from traditional FMCG, entertainment and pharma and life sciences clients to newer businesses that are more digitally focused on the platform and gig economies.",
			description_4: "Within the pharmaceutical sector, Jon has worked closely with Warner Lambert/Merial and GSK in particular,  He was heavily involved in the successful launch of Bio-Oil in the UK, and was instrumental in helping the business owners overcome the many related regulatory challenges they faced."
		},
		{
			name: "Marcos Richardson",
			position: "Legal and financial counsel",
			image: Marcos,
			description_1: "1995 – 2006 CEO of web analytics company WebtraffIQ before facilitating the company Trade Sale.",
			description_2: "Joined Publicis as EMEA Head of Digital ABPI Certified for Digital Pharma Practices and lead 38 Digital Executives from agencies Starcom, Razorfish, Digitas, Saatchi. Directly working with Astra Zeneca, Pfizer, Bayer and Procter & Gamble (P&G). Currently CEO of ZEN.",
			description_3: "CEO of Digital Innovation Group (DIG). Leading the agency drive into healthcare and pharmaceuticals, Audit, Strategy, Set up and Execution of Analytics, Search (organic and paid), programmatic, Social and technical. Clients include AbbVie, Sanofi Pasteur, Medtronic, Medela.",
			description_4: "Founder of ZEN, a system developed in line with pharmaceutical legal code of practices from PMCPA, IFPMA, EFPIA and FDA."
		},
		{
			name: "Dixon Jones",
			position: "Lead system strategist",
			image: Dixon,
			description_1: 'From 2009-2018, Dixon was the Marketing director of Majestic.com, a specialist search engine. This role gives unparalleled experience in developing Big Data and AI within SAAS solutions. During his tenure, Majestic won Queens Awards for innovation twice and was awarded Search technology of the year. He has co-founded InLinks with Fred Laurent from 2019 onwards, which helps machines understand the meaning in content. InLinks has already won the "best AI-driven SEO Tool" by Corporate Vision and "Best Search Software Tool" at the UK Search Awards.',
			description_2: 'With an MBA with a Strategic Management specialism, Dixon has been pushing the development of Internet technologies since 1999, starting as a founder of the Internet Marketing Agency "Receptional", which worked on accounts like GSK.',
			description_3: "On a personal level, Dixon is a public speaker in the Internet Marketing world, predominantly around SEO topics and has won several other accolades within the Internet Marketing world, including a lifetime Achievement award. He is also a keen chess player.",
		},
		{
			name: "Fred Laurent",
			position: "Technical lead",
			image: Fred,
			description_1: 'Fred build and manages the algorithms behind the technology. A world leading Natural Language Programming algorithm which has applications from this industry right through to search engine optimization technologies.',
			description_2: 'Fred built his algorithms after his time as an SEO with Semantic Marker. He has also worked in the aerospace industry and the transportation industry, working on logistics programming.',
		},
		{
			name: "Robert Thackery",
			position: "Technical lead",
			image: Robert,
			description_1: 'Robert Thackery has for many years worked as a strategist in brand and business development, soft transformation, behavioural change, marketing and marketing communications.  He has been a director of two international network advertising agencies (Foote Cone & Belding and Publicis).',
			description_2: 'Working with many institutions – from major blue-chip international companies, PLCs, UK professional bodies to SMEs – his sector experience is extensive.  This includes many b2C and B2B markets, including digital technology, energy, connectivity and telecommunications, financial services and fintech, as well as for many years in (Rx and OTC) healthcare with (amongst others) GSK, Hisamitsu, Merial (Sanofi) and P&G.',
			description_3: "He has a Master's degree from Cambridge University in English Literature.",
		},
		{
			name: "Gellan Watt",
			position: "Brand VP",
			image: Gelan,
			description_1: 'Gellan is an award-winning brand strategist and creative director. He founded his first marketing business in 2003, which went on to become a Top 10 UK agency and one of the largest independent agency groups in the UK - working for some of the largest brands in the world including Caterpillar, Apple, Pfizer and more. He and his business partners successfully exited the group in 2016.',
			description_2: 'Today, he works as a Non-Exec or equity for many high-growth businesses including PLCs, digital agencies, Fintechs and consumer products. An MBA, with a focus on usability and measurable impact - his focus is on creating technologies and strategies that create maximum value for users.',
			//description_3: "",
		},
	]
	firstName = '';
	lastName = '';
	email = '';
	company = '';

	formIsValid = false;

	firstNameIsValid = true;
	lastNameIsValid = true;
	emailIsValid = {
		isCorrect: true,
		isFull: true
	}

	/** Lifecycle */
	created() {
		this.init().catch(this.errorHandle);
	}

	/** Methods */
	async init() {
	}

	resetForm() {
		this.firstName = '';
		this.lastName = '';
		this.email = '';
		this.company = '';

		this.formIsValid = true;
		this.firstNameIsValid = true;
		this.lastNameIsValid = true;
		this.emailIsValid = {
			isCorrect: true,
			isFull: true
		}
	}


	checkValidateEmail(str: any) {
		return str.match(
			/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
		);
	};

	checkFormValid() {
		this.firstNameIsValid = !!this.firstName.trim().length;
		this.lastNameIsValid = !!this.lastName.trim().length;
		this.emailIsValid.isFull = !!this.email.trim().length;
		if (this.emailIsValid.isFull) {
			this.emailIsValid.isCorrect = !!this.checkValidateEmail(this.email.trim());
		}

		this.formIsValid = this.firstNameIsValid &&
			this.lastNameIsValid &&
			this.emailIsValid.isFull &&
			this.emailIsValid.isCorrect;
	}


	async formHandler() {
		try {
			const formData = new FormData();

			formData.append("firstName", this.firstName)
			formData.append("lastName", this.lastName)
			formData.append("email", this.email)
			formData.append("company", this.company)

			this.checkFormValid()

			if (this.formIsValid) {
				const res = await this.$api.post("/api/invite.php", formData);
				new Toast(document.getElementById('toast-email-sent')).show();
				this.resetForm()
			} else {
				new Toast(document.getElementById('toast-email-fail')).show();
			}
		} catch (err) {
			this.errorHandle(err);
		}
	}

	showModal(team: any) {
		this.currentTeam = team
	}
}
